import React from "react";
import { IMaskInput } from 'react-imask';
import {MediumPrimaryButton} from "@worthy-npm/clarity";
import styled from "styled-components";
import {updateMissingDetails} from "../../../actions/user";
import PropTypes from "prop-types";
import parsePhoneNumber from 'libphonenumber-js';

const PhoneNumberError = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
    color: #D06969 !important;
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
`;

class PhoneNumber extends React.Component {
    constructor(props) {
        super(props);
        this.user = props.user;
        this.state = {
            phoneNumber: '',
            sending: false,
            isValid: true,
        };
    }

    isSubmitEnable(){
        return this.state.phoneNumber.length === 10 && !this.state.sending;
    }

    setPhoneNumber(value){
        this.setState({phoneNumber: value});
    }

    placeholder(){
        const example = "(888) 222-0208";
        if (this.user.phone.startsWith('000000000')){
            return example;
        }

        const phoneNumber = parsePhoneNumber(this.user.phone, 'US');
        return phoneNumber ? phoneNumber.formatNational() : example;
    }

    submitPhoneNumber(){
        const phoneNumber = parsePhoneNumber(this.state.phoneNumber, 'US');
        if (phoneNumber && !phoneNumber.isValid()) {
            this.setState({ isValid:  false });
            if(window && window.Rollbar){
                window.Rollbar.warning('Phone number is invalid.', {
                    currentPhone: this.state.phoneNumber,
                    previousPhone: this.user.phone
                });
            }

            return '';
        }

        this.setState({sending: true});
        const { payload } = updateMissingDetails({
            phone: this.state.phoneNumber,
            user_id: this.user.id,
        });

        payload.then(() => {
            this.props.submitAppointment( ()=>{}, true);
        });
    }

    render() {
        return (
            <div className="offices-drop-off-wrapper">
                <Container>
                    <IMaskInput
                        disabled={this.state.sending}
                        mask='(#00) 000-0000'
                        definitions={{
                            '#': /[2-9]/,
                        }}
                        unmask={true}
                        onAccept={
                            (value) => {
                                this.setPhoneNumber(value);
                            }
                        }
                        placeholder= { this.placeholder()}
                        inputMode='tel'
                        type='tel'
                        style={{
                            height: '54px',
                            padding: '16px 24px',
                            borderRadius: '16px',
                            border: '1px solid #CCCCCC',
                            boxSizing: 'border-box',
                            fontSize: '16px',
                            fontWeight: 400,
                            fontFamily: 'Uncut Sans',
                            backgroundColor: '#F2F0EE',
                        }}
                    />
                    <style>
                        {`
                            ::placeholder {
                                color: #CCCCCC;
                            }`
                        }
                    </style>
                </Container>

                {
                    !this.state.isValid && <PhoneNumberError>Please enter a valid phone number</PhoneNumberError>
                }

                <div className="zip-code-next-btn" >
                    <MediumPrimaryButton
                        text="Submit"
                        click={async (stopAnimation) => {
                            stopAnimation()
                            this.submitPhoneNumber()
                        }}
                        disabled={!this.isSubmitEnable()}
                        overrideCSS={{
                            marginTop: '0',
                            height: '47px',
                            borderRadius: '16px',
                            textTransform: 'none',
                            font: '500 16px Roboto',
                        }}
                        overrideWrapperCSS={{}}
                    />
                </div>
            </div>
        )
    }
}

PhoneNumber.propTypes = {
    user: PropTypes.object.isRequired,
    submitAppointment: PropTypes.func.isRequired,
};

export default PhoneNumber;
